export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14869.8fead723.jpg";